import { STATIC_COMMON_FIELDS } from '../common';

import { extend } from '../../../util/jquery.js';

export const DYNAMIC_FIELDS = {
    OpenPrice: 'openPrice',
    HighPrice: 'highPrice',
    LowPrice: 'lowPrice',
    LastPrice: 'lastPrice',
    LastVolume: 'lastVolume',
    Volume: 'volume',
    LastMarket: 'lastMarketId',
    AskPrice: 'askPrice',
    AskSize: 'askSize',
    AskTime: 'askTime',
    AskDate: 'askDate',
    AskMarket: 'askMarket',
    BidPrice: 'bidPrice',
    BidSize: 'bidSize',
    BidTime: 'bidTime',
    BidDate: 'bidDate',
    BidMarket: 'bidMarket',
    ClosePrice: 'closePrice',
    ClosePriceDate: 'yesterdayCloseDate',
    High52W: 'week52HighPrice',
    HighDate52W: 'week52HighDate',
    Low52W: 'week52LowPrice',
    LowDate52W: 'week52LowDate',
    VWAP: 'VWAP',
    D954: 'instrumentStatus',
    SessionStatus: 'status',
    TradeDate: 'tradeDate',
    TradeTime: 'tradeTime',
    PrePrice: 'prePrice',
    PreChg: 'preChg',
    'PreChg%': 'preChg%',
    PreDate: 'preDate',
    PreTime: 'preTime',
    PostPrice: 'postPrice',
    PostChg: 'postChg',
    'PostChg%': 'postChg%',
    PostDate: 'postDate',
    PostTime: 'postTime',
    PrePostPrice: 'prePostPrice',
    PrePostDate: 'prePostDate',
    PrePostTime: 'prePostTime',
    PrePostChg: 'prePostChg',
    'PrePostChg%': 'prePostChg%',
    D20: 'yesterdayClosePrice',
    D30: 'numberOfTradesSinceMarketOpen',
    OpenInt: 'openInterest',
    NAV: 'NAV',
    D138: 'tradeIndicatorFlag',
    // 'D771T-': 'todayClosePrice', //not used
    // 'D772T-': 'todayCloseTime',
    // 'D773T-': 'todayCloseDate',
    Time: 'time',
    Date: 'date',
    D793: 'nonZeroBidPrice',
    D794: 'nonZeroAskPrice',
    D958: 'nonZeroBidDate',
    D959: 'nonZeroAskDate',
    D960: 'nonZeroBidTime',
    D961: 'nonZeroAskTime',
    Gid: 'MSPerformanceId',
    ExpirationDate: 'expirationDate',
    D1968: 'rtMarketCap',
    H15: 'chg',
    H16: 'chg%',
    D942: 'lastUpdateTime',
    MiddlePrice: 'middlePrice',
    strikeprice: 'strikePrice',
    Name: 'name',
    Spread: 'spread',
    HasTradeToday: 'hasTradeToday',
    PreviousNAV: 'previousNAV',
    ContractName: 'contractName'
};

export const STATIC_FIELDS = extend(
    {
        OS089: 'lastDividend',
        PD00D: 'oneYearReturn',
        PD00F: 'threeYearReturn',
        PD00H: 'fiveYearReturn',
        PD00B: 'ytdReturn',
        PD007: 'oneMonthReturn',
        PD009: 'threeMonthReturn',
        OS01X: 'tradeExchange',
        OF009: 'fundSize',
        OS00M: 'expenses',
        OF028: 'MSCategory',
        HS05A: 'MSStyleBox',
        RR01Y: 'MSRating', // Aka ST200
        OS378: 'fiscalYearEndMonth',
        PD003: 'oneDayReturn',
        PD005: 'oneWeekReturn',
        PM494: 'tenYearReturn',
        PM493: 'sixMonthReturn',
        PD014: 'twoYearReturn',
        PM495: 'fifteenYearReturn',
        OS088: 'lastDividendDate', // Aka ST476
        OS02W: 'averageVolume3Month',
        LA03Z: 'sectorCode',
        ST201: 'FVUncertainty',
        ST152: 'sector',
        ST153: 'industry',
        ST181: 'economicMoat',
        ST206: 'stewardShip',
        STA65: 'forwardDividendYield',
        STA0F: 'avgVolume2WKDaily',
        ST160: 'sharesOutstanding',
        ST415: 'PS',
        ST412: 'PE',
        ST410: 'PCF',
        STA44: 'beta',
        DIVYIELD: 'dividendYield',
        IPODATE: 'IPODate',
        PC_RATIO: 'PCFRatio',
        P_FCF_RATIO: 'PFCFRatio',
        STANDARDDEVIATION1YR: 'standardDeviationOneYear',
        STANDARDDEVIATION3YR: 'standardDeviationThreeYear',
        AA0A5: 'companyName',
        ST198: 'forwardPERatio',
        ST408: 'PB',
        ST159: 'marketCap',
        ST110: 'marketCapAsOfDate',
        ST263: 'EPSTTM',
        ST202: 'fairValueEstimate',
        OS603: 'priceToFairValue',
        OS060: 'nav',
        //start: component not use data points
        NETEXPENSERATIO: 'netExpenseRatio',
        BROADCATEGORYGROUPIDNEW: 'broadCategoryGroupId', // Aka LF035
        OS013: 'lastShareClassNetAsset',
        OS463: 'maximumFrontLoad',
        OS388: 'minimumInitialInvestment',
        STA4N: 'snpSectorName',
        STA4J: 'snpIndustryName',
        STA4H: 'snpSubIndustryName',
        STA4L: 'snpIndustryGroupName',
        PD001: 'returnEndDate',
        ST816: 'securityType2',
        ST82S: 'currentYield',
        OF00B: 'companyHomePage',
        ST156: 'equityStyleBox',
        ST292: 'dividendPerShareTTM',
        ST185: 'EPSEstGrowthMean5Year',
        STA0C: 'floatSharesShorted',
        AR111: 'dividendForYear1',
        AR112: 'dividendForYear2',
        HS00L: 'fixedIncomeStyleBox',
        RR01G: 'MSPerformanceFor3Year',
        RR01L: 'MSPerformanceFor5Year',
        RR01K: 'MSPerformanceFor10Year',
        OS09R: 'MSCreditRating',
        PM032: 'dividendYieldCurrent',
        ST299: 'dividendYieldCurrent',
        SECTYPE: 'secType',
        AC057: 'assetAllocation77Percentage',
        HS03W: 'averageMarketCap',
        HFR50: 'minimumInvestment',
        ST468: 'lastDividendDeclareDate',
        ST469: 'lastDividendRecordDate',
        ST470: 'lastDividendPayDate',
        UB170: 'latestDividendRecordDate',
        UB171: 'latestDividendDeclareDate',
        UB172: 'latestDividendPayDate',
        ST417: 'relativeStrength1Month',
        ST418: 'relativeStrength1Year',
        ST419: 'relativeStrength3Month',
        ST420: 'relativeStrength3Year',
        QV001: 'quantitativeMoatScore', // QV031
        QV002: 'quantitativeMoat', // QV032
        QV003: 'quantitativeValuationScore', // QV033
        QV004: 'quantitativeValuation', // QV034
        QV005: 'quantitativeValuationUncertaintyScore', // QV035
        QV006: 'quantitativeValuationUncertainty', // QV036
        QV007: 'quantitativeFinancialHealthScore', // QV037
        QV008: 'quantitativeFinancialHealth', // QV038
        QV009: 'quantitativeFairValueEstimate', // QV039
        QV010: 'quantitativeAsOfDate',
        HS11D: 'usEquityComposition',
        HS11E: 'nonUSEquityComposition',
        HS11F: 'fixedIncomeComposition',
        HS11I: 'otherComposition',
        HS11B: 'cashComposition',
        TD620: 'equityRegionNotClassifiedPercentage',
        TD619: 'northAmericaPercentage',
        TD631: 'unitedKingdomPercentage',
        TD669: 'europeDevelopedPercentage',
        TD634: 'europeEmergingPercentage',
        TD570: 'africaMiddleEastPercentage',
        TD637: 'japanPercentage',
        TD638: 'australasiaPercentage',
        TD640: 'asiaDevelopedPercentage',
        TD639: 'asiaEmergingPercentage',
        TD630: 'latinAmericaPercentage',
        HS000: 'portfolioDate',
        HS02F: 'effectiveDuration',
        HS05B: 'effectiveMaturity',
        HS00C: 'averageCreditQualityName',
        HS004: 'creditQualityAaa',
        HS003: 'creditQualityAa',
        HS002: 'creditQualityA',
        HS00G: 'creditQualityBbb',
        HS00F: 'creditQualityBb',
        HS00E: 'creditQualityB',
        HS00H: 'creditQualityBelowB',
        HS05E: 'creditQualityNotRated',
        TD128: 'basicMaterials',
        TD130: 'consumerCyclical',
        TD137: 'financialServices',
        TD134: 'realEstate',
        TD129: 'communicationServices',
        TD136: 'energy',
        TD133: 'industrials',
        TD135: 'technology',
        TD131: 'consumerDefensive',
        TD132: 'healthcare',
        TD138: 'utilities',
        TD161: 'government',
        TD163: 'corporate',
        TD164: 'securitized',
        TD162: 'municipal',
        TD165: 'cashAndEquivalents',
        TD166: 'derivative',
        PM002: 'secYield',
        RR152: 'upsideCaptureRatioFor1Year',
        RR158: 'downsideCaptureRatioFor1Year',
        RR011: 'sharpeRatioFor3Year',
        TTMYIELD: 'ttMYield',
        OS03S: 'turnover',
        TE375: 'gicsEnergy',
        TE376: 'gicsMaterials',
        TE377: 'gicsIndustrials',
        TE378: 'gicsConsumerDiscretionary',
        TE379: 'gicsConsumerStaples',
        TE380: 'gicsHealthcare',
        TE381: 'gicsFinancials',
        TE382: 'gicsInformationTechnology',
        TE383: 'gicsCommunicationServices',
        TE384: 'gicsUtilities',
        TE385: 'gicsRealEstate',
        KEY18: 'taxLossSub',
        KEY17: 'netExpenseRatio',
        KEY08: 'minInitialInvestment',
        KEY15: 'estTotalCapGain',
        KEY16: 'capGainsSellByDate',
        KEY09: 'equityAllWeatherScore',
        KEY11: 'kpbQualityScore',
        KEY10: 'kpbESGScore',
        KEY01: 'keyClassification1',
        KEY02: 'keyClassification2',
        KEY03: 'keyClassification3',
        KEY04: 'key2SMA',
        KEY05: 'keyRegion',
        KEY06: 'keyMarketCap',
        KEY07: 'keyAssetSuitability',
        KEY12: 'capGainsEstDate',
        KEY13: 'estShortTermCap',
        KEY14: 'estLongTermCap',
        KEY19: 'addedDate'
        //end: component not use data points
    },
    STATIC_COMMON_FIELDS
);
export const QUOTE_FIELDS = extend({}, DYNAMIC_FIELDS, STATIC_COMMON_FIELDS);

export const CHART_DATA_TYPE = {
    REALTIME_INTRADAY_LAST: 5,
    REALTIME_INTRADAY_RANGE: 6,
    REALTIME_HISTORICAL: 7
};
const Ratings = {
    FVUncertainty: {
        '1': 'Low',
        '2': 'Medium',
        '3': 'High',
        '4': 'Very High',
        '5': 'Extreme'
    }
};

const Months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
    ''
];

export const calculateSpecialField = (items, item) => {
    const name = STATIC_FIELDS[item.toUpperCase()] || item;
    let value = items[item];
    if (item === 'st160') {
        value = items[item] || items['S1314'] / 1000000;
    } else if (item === 'st201') {
        value = Ratings[name][value];
    } else if (value && /.*Date/i.test(name)) {
        value = value.replace(/(\d+)(-|\.)(\d+)(-|\.)(\d+)/, '$5$1$3');
    } else if (item === 'st299') {
        // dividendYieldCurrent dataPoint stock use st299, none-stock use pm032
        value = items['secType'] === 'ST' ? items[item] : items['pm032'];
    } else if (item === 'os378') {
        // fiscalYearEndMonth transform to string
        value = value ? Months[+value - 1] : '';
    }
    return { name, value };
};
